import styled from 'styled-components';

import { Box } from '@/components//Box';

import { ReactComponent as ArrowRight } from '@/assets/icons/arrowright-icon.svg';
import { ReactComponent as ArrowUp } from '@/assets/icons/arrowup-big-icon.svg';

export const Wrapper = styled.div`
  width: 100%;
  padding: 0 20px;
  overflow: visible;
`;

export const Header = styled.header`
  height: 100%;
  width: 100%;
`;

export const HeaderContent = styled(Box)<{ isOpen: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 20px 0px;
  background-color: transparent;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.almostBlack};

  svg {
    color: ${({ theme }) => theme.colors.almostBlack};
  }

  & > h4 {
    font-size: 1.25rem;
    font-weight: 500 !important;
  }
`;

export const Content = styled.div<{
  isOpen: boolean;
}>`
  transition: height 0.3s ease;
`;

export const ArrowRightIcon = styled(ArrowRight)``;

export const ArrowUpIcon = styled(ArrowUp)``;

export const SubMenuItemsContainer = styled.div<{
  $isOpen: boolean;
}>`
  display: none;
  overflow: visible;

  ${({ $isOpen }) =>
    $isOpen &&
    `
    display: flex;
    flex-direction: column;
    overflow: visible;
    `}
`;
